<template>
  <v-container class="component_main px-10 py-0">
    <v-row>
      <div class="col-md-12">
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page="-1"
          hide-default-footer
          dense
        >
          <template v-slot:item="props">
            <tr>
              <td class="text-left pa-2">{{props.item.nome}}</td>
              <td class="text-left pa-2">{{docTiposTitles[props.item.tipo]}}</td>
              <td class="text-left pa-2">{{props.item.descricao}}</td>
              <td class="text-left pa-2">{{modulosTitles[props.item.modulo]}}</td>
              <td class="text-left pa-2">{{props.item.data_publicacao | formatDate}}</td>
              <td class="text-center px-2 py-0" v-if="getdocument">
                <v-btn
                  small
                  color="primary"
                  icon
                  @click="selectItem(props.item, 'download')">
                  <v-icon small>fa-download</v-icon>
                </v-btn>
              </td>
              <td class="text-center px-2 py-0" v-if="updatedocument">
                <v-btn
                  small
                  color="primary"
                  icon>
                  <v-icon v-if="userData.PermissaoAcoes.portal.includes('updatedocument')" @click="selectItem(props.item, 'edit')" small>fa-pencil-alt</v-icon>
                  <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="text-center mb-6 pt-2 col-md-12">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="total_pages"
          @input="getList(filter, page)"
      ></v-pagination>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
moment.locale('pt-BR');
export default {
  data() {
    return {
      docTiposTitles:{},
      page: 1,
      itemsPerPage: 10,
      modNomes: [
        {
          mod_Nome: "Geral",
          id: "Geral",
        },
        {
          mod_Nome: "Autorizador",
          id: "Autorizador",
        },
      ],
    };
  },
  filters: {
    formatDate(date) {
      //return moment(date).format("L")
      return moment(date).format("DD/MM/YYYY [às] HH:mm[h]")
    },
  },
  methods: {
    userInfo() {
      let paramModal = {
        type: "error",
        title: "Atenção!",
        message: "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
        callback: null,
        btConfirm: { name: "Fechar", show: true },
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    }
  },
  watch:{
    docTipos:{
      deep: true,
      handler(){
        this.docTiposTitles = this.docTipos.reduce((obj, item)=>{
          obj[item.id]=item.descricao
          return obj
        },{})
      }
    },
    offset: {
      deep: true,
      handler(val) {
        this.page = val;
        this.$nextTick();
      }
    }
  },
  props: {
    docTipos: Array,
    filter: Object,
    getdocument: Boolean,
    getList: Function,
    headers: Array,
    list: Array,
    selectItem: Function,
    updatedocument: Boolean,
    userData: Object,
    modulosTitles: Object,
    offset: Number,
    total_pages: Number
  },
};
</script>

<style>
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
</style>
